(function () {
  window.egoeHomeHeader = {
    init: function () {
      var menu = document.querySelector('.menu');
      var expander = document.getElementById('header-expander');
      if (menu && expander) {
        expander.addEventListener('click', function () {
          menu.classList.toggle('is-expanded');
          expander.classList.toggle('is-active');
        });
      }
      if (typeof SimpleBar !== 'undefined') {
        document.querySelectorAll('[data-simplebar]').forEach(function (el) {
          try {
            if (!el.hasAttribute('data-simplebar-initialized')) {
              new SimpleBar(el);
              el.setAttribute('data-simplebar-initialized', '1');
            }
          } catch (e) {}
        });
      }
    },
  };
  window.egoeScrollToAnchor = {
    init: function () {
      document.querySelectorAll('a[href^="#"]').forEach(function (a) {
        var href = a.getAttribute('href');
        if (!href || href.length < 2) return;
        var target = document.querySelector(href);
        if (!target) return;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    },
  };
})();
